import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/customer/view/customer.view.query.gql"
import type {
  CustomerViewQuery,
  CustomerViewQueryVariables,
} from "@/v2-backoffice-client/customer/view/__types__/customer.view.query"

type Options = QueryHookOptions<CustomerViewQuery, CustomerViewQueryVariables>

export function useCustomerViewQuery(options?: Options) {
  return useQuery<CustomerViewQuery, CustomerViewQueryVariables>(query, options)
}
